/**
 * @author aldo-maciel
 */
import { $, Resource } from 'simpli-web-sdk'
import ReportsIRouteIndicatorResponseSchema from '@/schema/ReportsIRouteIndicatorResponse.schema'
import ReportsIRouteIndicatorResponseReportSchema from '@/schema/ReportsIRouteIndicatorResponseReport.schema.ts'
import CargaDestinatario from '@/model/resource/CargaDestinatario'
import moment from 'moment'
import Sistema from '@/model/resource/Sistema'
import Endereco from '@/model/resource/Endereco'
import CargaResponsavel from '@/model/resource/CargaResponsavel'

export default class ReportsIRouteIndicatorResponse extends Resource {

  get $schema() {
    if (ReportsIRouteIndicatorResponse.isReport) {
      return ReportsIRouteIndicatorResponseReportSchema(this)
    }
    return ReportsIRouteIndicatorResponseSchema(this)
  }

  get deliveryTime() {
    if (this.sistemaFinalizador && this.sistemaFinalizador.idSistemaPk === 2) {
      return $.t('classes.Carga.columns.baixaViaWeb')
    }
    if (this.dataInicioEntrega && this.dataFinalizacao) {
      const start = moment(this.dataInicioEntrega)
      const end = moment(this.dataFinalizacao)

      const duration = moment.duration(end.diff(start))
      const days = Math.floor(duration.asDays())
      const hours = Math.floor(duration.asHours()) % 24
      const minutes = Math.floor(duration.asMinutes()) % 60

      return `${ days }d ${ hours }h ${ minutes }m`
    }
    return '-'
  }

  get currentNro() {
    const emptyAddress = { endereco: { nro: null, logradouro: '' } }
    const { nro, logradouro = '' } = this.endereco || (this.destinatario || emptyAddress).endereco
    if (nro) {
      return nro
    }
    const [address = '', numbers] = logradouro.split(',')
    return (numbers || address).replace(/(\D){1,}([\d.]{0,5}).*/i, '$2')
  }

  static isReport = false
  readonly $name: string = 'ReportsIRouteIndicatorResponse'
  readonly $endpoint: string = '/user/indicador/indicator-iroute'

  $id = 0
  danfe: string | null = null
  dataBaixaSistema: string | null = null
  dataCriacao: string | null = null
  dataFinalizacao: string | null = null
  dataInicioEntrega: string | null = null
  dataPrevisao: string | null = null
  nroNotaFiscal: string | null = null
  sistemaFinalizador: Sistema | null = null
  embarcador: CargaResponsavel | null = null
  destinatario: CargaDestinatario | null = null
  transportador: CargaResponsavel | null = null
  endereco: Endereco | null = null
}
